import { SubmitTraitsGenerationContract } from 'src/js/modules/element-settings/helpers/stage-contracts';
import generateAdjustedEventTraits from 'src/js/modules/element-settings/helpers/generate-adjusted-event-traits';
import generateChangedOptionsTraits from 'src/js/modules/element-settings/helpers/generate-changed-options-traits';
import { iframeFieldNames } from '../../ws-media/constants/field-names';
import iframeEmbeddingTypes from '../constants/iframe-embedding-types';

const createSubmitTraitsIframeHandler =
  ({ prefix }) =>
  (flowData, context) => {
    const fieldsValues = context.getFieldsValues();
    const defaultFieldsValues = context.getDefaultFieldsValues();

    const allowFullScreenValue = fieldsValues[iframeFieldNames.IFRAME_ALLOW_FULLSCREEN];
    const defaultAllowFullScreenValue =
      defaultFieldsValues[iframeFieldNames.IFRAME_ALLOW_FULLSCREEN];
    const iframeEmbeddingType = fieldsValues[iframeFieldNames.IFRAME_EMBEDDING_TYPE];

    const desktopTraits =
      iframeEmbeddingType !== iframeEmbeddingTypes.URL ||
      allowFullScreenValue === defaultAllowFullScreenValue
        ? {}
        : generateAdjustedEventTraits(prefix, 'AllowFullScreen', allowFullScreenValue);

    const changedOptions = generateChangedOptionsTraits({ desktopTraits });

    return SubmitTraitsGenerationContract.create(changedOptions);
  };

export default createSubmitTraitsIframeHandler;
